<template>
  <div class="novice-tutorial-container">
    <div class="novice-tutorial">
      <h1>锁定案源详细攻略</h1>
      <p>点击下方视频立即查看</p>
      <div class="video-container">
        <Video v-if="videoUrl" :video-url="videoUrl" :poster="posterUrl"  class="viode"></Video>
      </div>
      <div class="footer-img">
        <img src="@/assets/imgs/novice-tutorial/img@2x.png" alt="">
      </div>
    </div>
  </div>
</template>

<script>
import Video from '@/components/video'
import {getCommonConfigKey} from "@a";
export default {
  name: "index",
  components:{
    Video
  },
  data(){
    return{
      videoUrl:'',
      posterUrl:require('@/assets/imgs/novice-tutorial/posterUrl.png')
    }
  },
  mounted() {
    getCommonConfigKey({paramName: 'new_learn_video'}).then(({data})=>{
      this.videoUrl = data.paramValue;
    })
  }
}
</script>

<style scoped lang="scss">
.novice-tutorial-container{
  background: #3A41A4;
  min-height: 100vh;
}
.novice-tutorial{
  background: url("~@/assets/imgs/novice-tutorial/BG@2x.png") no-repeat;
  background-size: 100% 100%;
  h1,p{
    text-align: center;
  }
  h1{
    font-size: 22px;
    font-weight: 500;
    color: #FFFFFF;
    padding: 40px 0 12px;
  }
  p{
    font-size: 14px;
    font-weight: 400;
    color: #D4B37D;
    padding-bottom: 26px;
  }
  .video-container{
    width: 343px;
    height: 220px;
    border-radius: 6px;
    overflow: hidden;
    background: rgba(0, 0, 0, 0.5);
    margin: 0 auto;
    .viode{

      width: 343px;
      height: 220px;
    }
  }
  .footer-img{
    padding-top: 42px;
    padding-bottom: 108px;
    img{
      margin: 0 auto;
      display: block;
      width: 343px;
      height: 226px;
    }
  }
}
</style>
